/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BereichIdentifier } from '../model/bereichIdentifier';
// @ts-ignore
import { BereichKopfdatenRequest } from '../model/bereichKopfdatenRequest';
// @ts-ignore
import { BereichLogoRequest } from '../model/bereichLogoRequest';
// @ts-ignore
import { BereichRequest } from '../model/bereichRequest';
// @ts-ignore
import { BereichRolleMultiRequest } from '../model/bereichRolleMultiRequest';
// @ts-ignore
import { BereichRolleRequest } from '../model/bereichRolleRequest';
// @ts-ignore
import { BereichTriggerDatenRequest } from '../model/bereichTriggerDatenRequest';
// @ts-ignore
import { BereichTriggerReihenfolgeRequest } from '../model/bereichTriggerReihenfolgeRequest';
// @ts-ignore
import { BereichTriggerRequest } from '../model/bereichTriggerRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class VerwaltenCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostBereichAnlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/anlegen
     * @param bereichRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichAnlegen(bereichRequest: BereichRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichAnlegen(bereichRequest: BereichRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichAnlegen(bereichRequest: BereichRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichAnlegen(bereichRequest: BereichRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichRequest === null || bereichRequest === undefined) {
            throw new Error('Required parameter bereichRequest was null or undefined when calling postBereichAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/entfernen
     * @param bereichRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichEntfernen(bereichRequest: BereichRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichEntfernen(bereichRequest: BereichRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichEntfernen(bereichRequest: BereichRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichEntfernen(bereichRequest: BereichRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichRequest === null || bereichRequest === undefined) {
            throw new Error('Required parameter bereichRequest was null or undefined when calling postBereichEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichKopfdatenAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/kopfdaten
     * @param bereichKopfdatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichKopfdatenAktualisieren(bereichKopfdatenRequest: BereichKopfdatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichKopfdatenAktualisieren(bereichKopfdatenRequest: BereichKopfdatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichKopfdatenAktualisieren(bereichKopfdatenRequest: BereichKopfdatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichKopfdatenAktualisieren(bereichKopfdatenRequest: BereichKopfdatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichKopfdatenRequest === null || bereichKopfdatenRequest === undefined) {
            throw new Error('Required parameter bereichKopfdatenRequest was null or undefined when calling postBereichKopfdatenAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/kopfdaten`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichKopfdatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichLogoAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/logo
     * @param bereichLogoRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichLogoAktualisieren(bereichLogoRequest: BereichLogoRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichLogoAktualisieren(bereichLogoRequest: BereichLogoRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichLogoAktualisieren(bereichLogoRequest: BereichLogoRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichLogoAktualisieren(bereichLogoRequest: BereichLogoRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichLogoRequest === null || bereichLogoRequest === undefined) {
            throw new Error('Required parameter bereichLogoRequest was null or undefined when calling postBereichLogoAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/logo`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichLogoRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichRolleEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/rolle/entfernen
     * @param bereichRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichRolleEntfernen(bereichRolleRequest: BereichRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichRolleEntfernen(bereichRolleRequest: BereichRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichRolleEntfernen(bereichRolleRequest: BereichRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichRolleEntfernen(bereichRolleRequest: BereichRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichRolleRequest === null || bereichRolleRequest === undefined) {
            throw new Error('Required parameter bereichRolleRequest was null or undefined when calling postBereichRolleEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/rolle/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichRolleHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/rolle/hinzufuegen
     * @param bereichRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichRolleHinzufuegen(bereichRolleRequest: BereichRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichRolleHinzufuegen(bereichRolleRequest: BereichRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichRolleHinzufuegen(bereichRolleRequest: BereichRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichRolleHinzufuegen(bereichRolleRequest: BereichRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichRolleRequest === null || bereichRolleRequest === undefined) {
            throw new Error('Required parameter bereichRolleRequest was null or undefined when calling postBereichRolleHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/rolle/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichRolleHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/rolle/hinzufuegen/multi
     * @param bereichRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichRolleHinzufuegenMulti(bereichRolleMultiRequest: BereichRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichRolleHinzufuegenMulti(bereichRolleMultiRequest: BereichRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichRolleHinzufuegenMulti(bereichRolleMultiRequest: BereichRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichRolleHinzufuegenMulti(bereichRolleMultiRequest: BereichRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichRolleMultiRequest === null || bereichRolleMultiRequest === undefined) {
            throw new Error('Required parameter bereichRolleMultiRequest was null or undefined when calling postBereichRolleHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/rolle/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichTriggerAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/trigger/aktualisieren
     * @param bereichTriggerDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichTriggerAktualisieren(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichTriggerAktualisieren(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichTriggerAktualisieren(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichTriggerAktualisieren(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichTriggerDatenRequest === null || bereichTriggerDatenRequest === undefined) {
            throw new Error('Required parameter bereichTriggerDatenRequest was null or undefined when calling postBereichTriggerAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/trigger/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichTriggerDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichTriggerEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/trigger/entfernen
     * @param bereichTriggerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichTriggerEntfernen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichTriggerEntfernen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichTriggerEntfernen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichTriggerEntfernen(bereichTriggerRequest: BereichTriggerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichTriggerRequest === null || bereichTriggerRequest === undefined) {
            throw new Error('Required parameter bereichTriggerRequest was null or undefined when calling postBereichTriggerEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/trigger/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichTriggerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichTriggerHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/trigger/hinzufuegen
     * @param bereichTriggerDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichTriggerHinzufuegen(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichTriggerHinzufuegen(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichTriggerHinzufuegen(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichTriggerHinzufuegen(bereichTriggerDatenRequest: BereichTriggerDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichTriggerDatenRequest === null || bereichTriggerDatenRequest === undefined) {
            throw new Error('Required parameter bereichTriggerDatenRequest was null or undefined when calling postBereichTriggerHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/trigger/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichTriggerDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBereichTriggerReihenfolgeSetzen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * BereichNichtGefunden: (DisplaysteuerungBereichNichtGefunden) * BereichGeloescht: (DisplaysteuerungBereichGeloescht) * BenutzerHatKeinZugriff: (DisplaysteuerungBenutzerHatKeinZugriff) * BenutzerHatKeinAdminZugriff: (DisplaysteuerungBenutzerHatKeinAdminZugriff) 
     * @endpoint post /api/disp/verwalten/v1/bereich/trigger/reihenfolge
     * @param bereichTriggerReihenfolgeRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichTriggerReihenfolgeSetzen(bereichTriggerReihenfolgeRequest: BereichTriggerReihenfolgeRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BereichIdentifier>;
    public postBereichTriggerReihenfolgeSetzen(bereichTriggerReihenfolgeRequest: BereichTriggerReihenfolgeRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BereichIdentifier>>;
    public postBereichTriggerReihenfolgeSetzen(bereichTriggerReihenfolgeRequest: BereichTriggerReihenfolgeRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BereichIdentifier>>;
    public postBereichTriggerReihenfolgeSetzen(bereichTriggerReihenfolgeRequest: BereichTriggerReihenfolgeRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichTriggerReihenfolgeRequest === null || bereichTriggerReihenfolgeRequest === undefined) {
            throw new Error('Required parameter bereichTriggerReihenfolgeRequest was null or undefined when calling postBereichTriggerReihenfolgeSetzen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/verwalten/v1/bereich/trigger/reihenfolge`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichTriggerReihenfolgeRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
